module.exports = __webpack_public_path__ + "static/media/andrew-ackerman.bc47a69b.png";